import { render, staticRenderFns } from "./EconomicTable.vue?vue&type=template&id=5961b5fe&scoped=true"
import script from "./EconomicTable.vue?vue&type=script&lang=js"
export * from "./EconomicTable.vue?vue&type=script&lang=js"
import style0 from "./EconomicTable.vue?vue&type=style&index=0&id=5961b5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961b5fe",
  null
  
)

export default component.exports